import { useCallback } from 'react';
import { prop } from 'ramda';

import { JACKPOTS_REDUCER } from 'js/store/constants';
import { useCustomSelector } from 'js/store/hooks';

const sortingMethod = (a, b) => {
    if (a > b) {
        return -1;
    }

    if (b > a) {
        return 1;
    }

    return 0;
};

export const useGameSorting = (sortingType) => {
    const jackpotList = useCustomSelector(JACKPOTS_REDUCER, prop('jackpots'));

    return useCallback((gameA, gameB) => {
        switch (sortingType) {
            case '2': { // Popular
                return sortingMethod(gameA.popular, gameB.popular);
            }
            case '3': { // New
                return sortingMethod(gameA.new, gameB.new);
            }
            case '4': { // Jackpot size
                const jackpotA = jackpotList?.[gameA.jackpotCode]?.amount || 0;
                const jackpotB = jackpotList?.[gameB.jackpotCode]?.amount || 0;

                return sortingMethod(jackpotA, jackpotB);
            }
            default: {
                const nameA = gameA.name?.toLowerCase().replace(/[^a-z]+/, '') || '';
                const nameB = gameB.name?.toLowerCase().replace(/[^a-z]+/, '') || '';

                return sortingMethod(nameB, nameA);
            }
        }
    }, [jackpotList, sortingType]);
};
